import { render } from "./MapEditOptionsGeneral.vue?vue&type=template&id=00f15314&scoped=true&bindings={\"modelValue\":\"props\",\"mapData\":\"options\",\"showFullscreenToggleChange\":\"options\",\"fullscreenOnFocusChange\":\"options\"}"
import script from "./MapEditOptionsGeneral.vue?vue&type=script&lang=js"
export * from "./MapEditOptionsGeneral.vue?vue&type=script&lang=js"

import "./MapEditOptionsGeneral.vue?vue&type=style&index=0&id=00f15314&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00f15314"

export default script